import DeleteAddressBtn from './Addresses/deleteAddressBtn';

customElements.define('delete-address-btn', DeleteAddressBtn, { extends: 'a' });

import AddressBtn from './Addresses/addressBtn';

customElements.define('address-btn', AddressBtn, { extends: 'a' });

import IndexTabControl from './News/IndexTabControl';

customElements.define('index-tab-control', IndexTabControl, { extends: 'button' });

import MyAccountCard from './Account/MyAccountCard';

customElements.define('my-account-card', MyAccountCard,{extends: 'div'});
